import { Locale } from 'Locale';

export const linkPost = (locale: Locale, postSlug: string, category: string | null): string =>
	`/${locale}/p/${postSlug}${category !== null ? `?category=${category}` : ''}`;
